module.exports = __webpack_public_path__ + "static/media/LogoEuros.a7f12b3a.svg";